import React, {useState} from 'react'
import DashboardLayout from '../components/DashboardLayout';
import PrinterList from '../components/PrinterList';

export default function PrinterPage() {
    const [modal_open, set_modal_open] = useState(false)

    return (
      <DashboardLayout>
        <PrinterList></PrinterList>
      </DashboardLayout>

    )
}